export const getContextualErrorMessage = (basePath: Array<string | number>, message: string): string => {
  // Extract scenario and unit information from the path
  const pathStr = basePath.join('.');
  let context = '';

  if (pathStr.includes('targetScenarios')) {
    const scenarioMatch = pathStr.match(/targetScenarios\.(\d+)/);
    const unitMatch = pathStr.match(/scenarioPayload\.(\d+)/);

    if (scenarioMatch && unitMatch) {
      const scenarioIndex = parseInt(scenarioMatch[1]) + 1;
      const unitIndex = parseInt(unitMatch[1]) + 1;
      context = `Cenário ${scenarioIndex}, Unidade ${unitIndex}: `;
    }
  } else if (pathStr.includes('baseScenario')) {
    const unitMatch = pathStr.match(/scenarioPayload\.(\d+)/);
    if (unitMatch) {
      const unitIndex = parseInt(unitMatch[1]) + 1;
      context = `Cenário Base, Unidade ${unitIndex}: `;
    }
  }

  return context + message;
};
